export enum TenantUserJoined {
  Creator,
  JoinedByInvitation,
  JoinedByLink,
  JoinedByPublicUrl,
}
